(function (module) {
    "use strict";
    module.directive('dropdown', ['$rootScope', '$translate', 'LocaleService', 'CrossMessageCommunication', dropdown]);

    function dropdown($rootScope, $translate, LocaleService, CrossMessageCommunication) {
        return {
            restrict: 'A',
            template: '<div class="dropdown-container" ng-class="{ show: listVisible }">' +
            '<div class="dropdown-display" ng-click="show();" ng-class="{ clicked: listVisible }">' +
            '<span>{{display}}</span>' +
            '<span class="arrow chevron small" ng-class="listVisible ? \' bottom\' : \'left\'"></span>' +
            '</div>' +
            '<div class="dropdown-list">' +
            '<div>' +
            '<div ng-repeat="item in list" ng-click="select(item)" ng-class="{ selected: isSelected(item) }">' +
            '<span>{{item}}</span>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>',
            scope: {
                list: '=',
                selected: '='
            },
            link: function (scope) {
                scope.listVisible = false;
                scope.isPlaceholder = true;

                scope.select = function (item) {
                    scope.isPlaceholder = false;
                    scope.selected = item;
                    scope.changeLanguage(scope.selected);
                };

                scope.changeLanguage = function (locale) {
                    var iframeElement = document.getElementById('bpmIframe').contentWindow;
                    CrossMessageCommunication.send(iframeElement, "LanguageChanged", locale);
                    $translate.use(scope.locale);
                    LocaleService.setLocaleByDisplayName(locale);
                };

                scope.isSelected = function (item) {
                    return item === scope.selected;
                };

                scope.show = function () {
                    scope.listVisible = !scope.listVisible;
                };

                $rootScope.$on("documentClicked", function (inner, target) {
                    if (!$(target[0]).is(".dropdown-display.clicked") && !$(target[0]).parents(".dropdown-display.clicked").length > 0)
                        scope.$apply(function () {
                            scope.listVisible = false;
                        });
                });

                scope.$watch("selected", function (value) {
                    scope.display = scope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
                });
            }
        }
    }
})(angular.module('Dropdown.translate', []));